import Header from './components/header';
import Main from './components/main';
import Project from './components/projectSection';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header/>
      <Main/>
      <Project/>
    </div>
  );
}

export default App;
